import React, { useState, useMemo } from 'react'
import Autosuggest from 'react-autosuggest'
import TextField from '@material-ui/core/TextField'
import Paper from '@material-ui/core/Paper'
import MenuItem from '@material-ui/core/MenuItem'
import Popper from '@material-ui/core/Popper'
import { Field, change } from 'redux-form'
import { makeStyles } from '@material-ui/core/styles'
import { useDispatch } from 'react-redux'
import { fetchCircleAutoComplete } from '../../../redux/actions'
import { useSelector, shallowEqual } from 'react-redux'
import { circleAutoCompleteSuggestionSelector } from '../../../redux/selectors'
import { useConstant } from '../../../utilities/useConstant'
import { debounceMilliseconds, minimumSearchCharacters } from '../../../utilities/constants'
import LateralityValue from '../../circle/components/LateralityValue'

var debounce = require('lodash/debounce')

const useASStyles = makeStyles((theme) => ({
	root: {
		//height: 75,
		color: '#fff',
		flexGrow: 1
	},
	container: {
		position: 'relative'
	},
	suggestionsContainerOpen: {
		position: 'absolute',
		zIndex: 1,
		marginTop: theme.spacing(1),
		left: 0,
		right: 0
	},
	suggestion: {
		display: 'block'
	},
	suggestionsList: {
		margin: 0,
		padding: 0,
		listStyleType: 'none'
	},
	optionStyle: {
		overflowY: 'auto',
		'WebkitOverflowScrolling': 'touch',
		'& ul li .MuiMenuItem-root': {
			whiteSpace: 'normal',
		}
	},
	divider: {
		height: theme.spacing(2)
	}
}))

const styles = {

}

// const useLabelStyles = makeStyles({
// 	root: {
// 		color: '#fff',
// 		marginLeft: '-2px'
// 	}
// })

// const useInputStyles = makeStyles({
// 	root: {
// 		color: '#fff',
// 		backgroundColor: 'rgb(36, 48, 65)'
// 	},
// 	focused: {
// 		color: '#fff',
// 		backgroundColor: 'rgb(36, 48, 65)',
// 		'&$focused': {
// 			color: '#fff',
// 			backgroundColor: 'rgb(36, 48, 65)'
// 		}
// 	}
// })

// const useFormHelperTextStyles = makeStyles({
// 	root: {
// 		marginLeft: 0,
// 		marginRight: 0
// 	}
// })

export const SponsorSelectorControl = ({
	label,
	meta: { initial, form, touched, invalid, error },
	input,
	noMatchText,
	onCircleSelected
}) => {
	const circles = useSelector(circleAutoCompleteSuggestionSelector, shallowEqual)
	const dispatch = useDispatch()
	const [ noMatch, setNoMatch ] = useState(true)
	const [ matchSelected, setMatchSelected ] = useState(false)
	const [ stateSuggestions, setSuggestions ] = useState(circles)
	const classes = useASStyles()
	const [ anchorEl, setAnchorEl ] = React.useState(null)
	const [ state, setState ] = React.useState({
		label: ''
	})

	const handleSuggestionsFetchRequested = ({ value }) => {
		dispatch(fetchCircleAutoComplete(value, noMatchText))
	}

	const onSuggestionRequested = useConstant(() =>
		debounce(handleSuggestionsFetchRequested, debounceMilliseconds, { leading: true })
	)

	function renderSuggestion(suggestion, { query, isHighlighted }) {
		return (
			<MenuItem data-testid="sponsor-selector-control-menu-item" selected={isHighlighted} component='div'>
				<div>{suggestion.name}{' | '}<LateralityValue isBilateral={suggestion.isBilateral}/></div>
			</MenuItem>
		)
	}

	function renderInputComponent(inputProps) {
		const { classes, inputRef = () => {}, ref, ...other } = inputProps

		return (
			<div style={{ marginBottom: '25px' }}>
				<TextField
					data-testid="sponsor-selector-control"
					fullWidth
					autoComplete={false}
					error={touched && invalid}
					helperText={touched && error}
					style={styles}
					InputProps={{
						...inputProps,
						inputRef: (node) => {
							ref(node)
							inputRef(node)
						}
					}}
					inputProps={{ autocomplete: 'dont' }}
					shrink='true'
					variant='filled'
					color='secondary'
					{...other}
				/>
			</div>
		)
	}

	const handleSuggestionsClearRequested = () => {
		setSuggestions([])
	}

	const onSuggestionSelected = (event, { suggestion, suggestionValue, suggestionIndex, sectionIndex, method }) => {
		if (suggestion && suggestion.id > -1) {
			dispatch(change(form, input.name, suggestion.id))
			setNoMatch(false)
			setMatchSelected(true)

			if(onCircleSelected)
			{
				onCircleSelected(suggestion)
			}
		} else {
			setState({
				...state,
				value: null,
				label: ''
			})
			setNoMatch(true)
			dispatch(change(form, input.name, ''))
		}
	}

	function getSuggestionValue(suggestion) {
		return suggestion
	}

	const autosuggestProps = {
		renderInputComponent,
		onSuggestionsClearRequested: handleSuggestionsClearRequested,
		onSuggestionSelected: onSuggestionSelected,
		getSuggestionValue,
		renderSuggestion
	}

	const handleChange = (event, { newValue }) => {
		if (newValue && newValue.id && newValue.id > 0) {
			dispatch(change(form, input.name, newValue.id))
			setNoMatch(false)
			setMatchSelected(true)
		} else {
			dispatch(change(form, input.name, null))
			setNoMatch(true)
			setMatchSelected(false)
			if(onCircleSelected)
			{
				onCircleSelected(null)
			}
		}
		setState({
			...state,
			value: newValue,
			label: newValue && newValue.name ? newValue.name : newValue
		})
	}

	return (
		<div className={classes.root}>
			<Autosuggest
				data-testid="sponsor-selector-control-autosuggest"
				{...autosuggestProps}
				suggestions={circles}
				onSuggestionsFetchRequested={onSuggestionRequested}
				inputProps={{
					classes,
					id: input.name,
					label: label,
					value: state.label,
					onChange: handleChange,

					onBlur: (e, x) => {
						setAnchorEl(null)
						//input.onChange(e.target.value)
						if (noMatch || !matchSelected) {
							setState({
								...state,
								value: '',
								label: ''
							})
							dispatch(change(form, input.name, ''))
						}
					},
					inputRef: (node) => {
						setAnchorEl(node)
					}
				}}
				theme={{
					suggestionsList: classes.suggestionsList,
					suggestion: classes.suggestion
				}}
				renderSuggestionsContainer={(options) => (
					<Popper data-testid="sponsor-selector-control-popper" anchorEl={anchorEl} open={Boolean(options.children)} style={{ zIndex: 1300 }}
                		placement="bottom-start"
						modifiers={{
      						flip: {
        						enabled: false,
      						},
	  						preventOverflow: {
      						  	enabled: true,
      						  	boundariesElement: 'viewPort',
      						},
						}}
					>
						<Paper
							data-testid="sponsor-selector-control-paper"
							square
							{...options.containerProps}
							className={classes.optionStyle}
							style={{
								maxHeight: anchorEl ? window.innerHeight-anchorEl.parentElement.getBoundingClientRect().bottom : undefined,
								width: anchorEl ? anchorEl.parentElement.clientWidth : undefined,
								marginLeft: anchorEl ? -(anchorEl.parentElement.clientWidth-anchorEl.clientWidth) : undefined }}>
							{options.children}
						</Paper>
					</Popper>
				)}
			/>
		</div>
	)
}

export default ({
	label,
	name,
	validators,
	suggestions,
	maxLength = 255,
	noMatchText = 'No Entries Found',
	onCircleSelected,
	...other
}) => {
	return (
		<Field
			data-testid="sponsor-selector-control-field"
			name={name}
			component={SponsorSelectorControl}
			label={label}
			maxLength={maxLength}
			fullWidth
			validate={validators}
			noMatchText={noMatchText}
			onCircleSelected={onCircleSelected}
			{...other}
		/>
	)
}
